<div class="page">
  <div class="page__container">
    <ng-container *ngIf="hasValidatedSendersList">
      <ng-template #modalAddEditAlphaDisabled let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalDeleteSubSenderAlphaForm()"
          (dismiss)="d()"
          cancelButtonEnable="true"
          title="{{ 'sms_senders_error_alpha_register_title' | translate }}"
          text="{{ 'sms_senders_error_alpha_register_message' | translate }}"
        ></wsb-modal>
      </ng-template>
      <ng-template #modalAddEditAlpha let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalAddEditAlphaForm()"
          cancelButtonEnable="true"
          [primaryDisabled]="addResellSenderAlphaForm.invalid"
          primaryButtonText="{{ 'senders_new_ok' | translate }}"
          (dismiss)="d()"
          title="{{ 'sender_new' | translate }}"
        >
          <div body>
            <!-- <form *ngIf="!senderToEdit || senderToEditFull" [formGroup]="addResellSenderAlphaForm"> -->
            <form [formGroup]="addResellSenderAlphaForm">
              <div class="form-group row">
                <label for="subaccount" class="col-sm-4" translate>reseller_senders_new_subaccount</label>
                <div class="col-sm-8">
                  <ng-select
                    [items]="itemsSubaccounts"
                    id="subaccount"
                    bindValue="value"
                    (search)="onSearch($event)"
                    bindLabel="label"
                    formControlName="subaccount"
                    [clearable]="false"
                    class="form-control bulk-options-changer"
                    (scrollToEnd)="onScrollToEnd()"
                  >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      <span class="ng-value-label">{{ item.label | translate }}</span>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                      <span>{{ item.label | translate }}</span>
                    </ng-template>
                  </ng-select>
                  <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('subaccount')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row">
                <label for="sender" class="col-sm-4" translate>sender_sender</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    id="sender"
                    formControlName="sender"
                    wsbAppControlValidator
                    [fc]="addResellSenderAlphaForm.get('sender')"
                  />
                  <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('sender')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row">
                <label for="contactName" class="col-sm-4" translate>sender_new_name</label>
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-sm-6">
                      <input
                        type="text"
                        class="form-control"
                        id="contactName"
                        formControlName="contactName"
                        wsbAppControlValidator
                        placeholder="{{ 'contact_name' | translate }}"
                        [fc]="addResellSenderAlphaForm.get('contactName')"
                      />
                      <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('contactName')"></wsb-validation-error-msg>
                    </div>
                    <div class="col-sm-6">
                      <input
                        type="text"
                        class="form-control"
                        id="contactSurname"
                        formControlName="contactSurname"
                        wsbAppControlValidator
                        placeholder="{{ 'contact_surname' | translate }}"
                        [fc]="addResellSenderAlphaForm.get('contactSurname')"
                      />
                      <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('contactSurname')"></wsb-validation-error-msg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="companyName" class="col-sm-4" translate>sms_senders_new_company</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    id="companyName"
                    formControlName="companyName"
                    wsbAppControlValidator
                    [fc]="addResellSenderAlphaForm.get('companyName')"
                  />
                  <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('companyName')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row">
                <label for="contactAddress" class="col-sm-4" translate>sms_senders_new_address</label>
                <div class="col-sm-8">
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <input
                        type="text"
                        class="form-control"
                        id="contactAddress"
                        formControlName="contactAddress"
                        wsbAppControlValidator
                        placeholder="{{ 'sms_senders_new_address_ph' | translate }}"
                        [fc]="addResellSenderAlphaForm.get('contactAddress')"
                      />
                      <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('contactAddress')"></wsb-validation-error-msg>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <input
                        type="text"
                        class="form-control"
                        id="contactPostalCode"
                        formControlName="contactPostalCode"
                        wsbAppControlValidator
                        placeholder="{{ 'sms_senders_new_postcode_ph' | translate }}"
                        [fc]="addResellSenderAlphaForm.get('contactPostalCode')"
                      />
                      <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('contactPostalCode')"></wsb-validation-error-msg>
                    </div>
                    <div class="col-sm-6">
                      <input
                        type="text"
                        class="form-control"
                        id="contactCity"
                        formControlName="contactCity"
                        wsbAppControlValidator
                        placeholder="{{ 'account_city' | translate }}"
                        [fc]="addResellSenderAlphaForm.get('contactCity')"
                      />
                      <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('contactCity')"></wsb-validation-error-msg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="vatNumber" class="col-sm-4" translate>account_piva</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    id="vatNumber"
                    formControlName="vatNumber"
                    wsbAppControlValidator
                    [fc]="addResellSenderAlphaForm.get('vatNumber')"
                  />
                  <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('vatNumber')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row">
                <label for="fiscalCode" class="col-sm-4" translate>account_cf</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    id="fiscalCode"
                    formControlName="fiscalCode"
                    wsbAppControlValidator
                    [fc]="addResellSenderAlphaForm.get('fiscalCode')"
                  />
                  <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('fiscalCode')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row">
                <label for="contactInfo" class="col-sm-4" translate>account_pec</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    id="contactInfo"
                    formControlName="contactInfo"
                    wsbAppControlValidator
                    [fc]="addResellSenderAlphaForm.get('contactInfo')"
                  />
                  <wsb-validation-error-msg [fc]="addResellSenderAlphaForm.get('contactInfo')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="d-flex align-items-center me-3">
                    <wsb-ui-checkbox
                      [checked]="addResellSenderAlphaForm.get('authorize').value"
                      [checkboxId]="'authorize'"
                      class="me-1 pt-1"
                      formControlName="authorize"
                    ></wsb-ui-checkbox>
                    <label class="ms-2 mt-2" [innerHTML]="'check_terms' | translate"></label>
                  </div>
                  <wsb-validation-error-msg
                    class="d-block mt-2"
                    [fc]="addResellSenderAlphaForm.get('authorize')"
                  ></wsb-validation-error-msg>
                </div>
              </div>
            </form>
          </div>
        </wsb-modal>
      </ng-template>
      <ng-template #modalDeleteAlpha let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalDeleteSubSenderAlphaForm()"
          (dismiss)="d()"
          cancelButtonEnable="true"
          title="{{ 'common_attention' | translate }}"
          text="{{ 'sender_delete_confirm' | translate }}"
        ></wsb-modal>
      </ng-template>
      <h1 class="page__title h2 mb-5">{{ 'sender_alphanumeric' | translate }}</h1>
      <wsb-atlas-button *ngIf="canManageAlphaSenders" class="my-3" [label]="'sender_new'" (click)="openmodalAddEditAlpha()">{{
        'sender_new' | translate
      }}</wsb-atlas-button>
      <div class="my-5">
        <wsb-atlas-grid
          #alphaGrid
          *ngIf="tableResellSendersAlphaColumnDefs && tableResellSendersNumericGridOptions"
          class="atlas-grid-simplest mt-2"
          [loading]="tableResellSendersAlphaLoading"
          [columnDefs]="tableResellSendersAlphaColumnDefs"
          [options]="tableResellSendersAlphaGridOptions"
          [components]="components"
          [@gridIsLoaded]="gridAnimationStateAlpha"
        ></wsb-atlas-grid>
      </div>
    </ng-container>
    <ng-container>
      <ng-template #modalAddNumeric let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalAddNumericForm()"
          cancelButtonEnable="true"
          primaryButtonText="{{ 'senders_new_ok' | translate }}"
          (dismiss)="d()"
          title="{{ 'sender_new' | translate }}"
          [primaryDisabled]="inputPhone.phoneNumber.invalid || addResellSenderNumericForm.invalid"
        >
          <div body>
            <form [formGroup]="addResellSenderNumericForm">
              <div class="form-group row">
                <label for="subaccount" class="col-sm-4" translate>reseller_senders_new_subaccount</label>
                <div class="col-sm-8">
                  <ng-select
                    [items]="itemsSubaccounts"
                    id="subaccount"
                    bindValue="value"
                    bindLabel="label"
                    formControlName="subaccount"
                    [clearable]="false"
                    (search)="onSearch($event)"
                    class="form-control bulk-options-changer"
                    (scrollToEnd)="onScrollToEnd()"
                  >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      <span class="ng-value-label">{{ item.label | translate }}</span>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                      <span>{{ item.label | translate }}</span>
                    </ng-template>
                  </ng-select>
                  <wsb-validation-error-msg [fc]="addResellSenderNumericForm.get('subaccount')"></wsb-validation-error-msg>
                </div>
              </div>
              <div class="form-group row">
                <label for="subaccount" class="col-sm-4" translate>sender_numeric_number</label>
                <div class="col-sm-8">
                  <wsb-atlas-inputphone
                    #inputPhone
                    name="number"
                    [cssClass]="'form-control'"
                    [formControlName]="'number'"
                  ></wsb-atlas-inputphone>
                  <wsb-validation-error-msg [fc]="inputPhone.phoneNumber"></wsb-validation-error-msg>
                </div>
              </div>
            </form>
          </div>
        </wsb-modal>
      </ng-template>
      <ng-template #modalDeleteNumeric let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalDeleteNumericForm()"
          (dismiss)="d()"
          cancelButtonEnable="true"
          title="{{ 'common_attention' | translate }}"
          text="{{ 'sender_delete_confirm' | translate }}"
        ></wsb-modal>
      </ng-template>
      <h1 class="page__title h2 mb-5">{{ 'sender_numeric' | translate }}</h1>
      <wsb-atlas-button class="my-3" [label]="'sender_new'" (click)="openModalAddNumeric()">{{
        'sender_new' | translate
      }}</wsb-atlas-button>
      <div class="my-5">
        <wsb-atlas-grid
          #numericGrid
          *ngIf="tableResellSendersNumericGridOptions"
          class="atlas-grid-simplest mt-2"
          [loading]="tableSendersNumericLoading"
          [columnDefs]="tableResellSendersNumericColumnDefs"
          [options]="tableResellSendersNumericGridOptions"
          [components]="components"
          [@gridIsLoaded]="gridAnimationStateNumeric"
        ></wsb-atlas-grid>
      </div>
    </ng-container>
  </div>
</div>
